import arrow1 from 'public/assets/lottie/arrow-sequences/arrow-1.json';
import arrow2 from 'public/assets/lottie/arrow-sequences/arrow-2.json';
import arrow3 from 'public/assets/lottie/arrow-sequences/arrow-3.json';
import arrow4 from 'public/assets/lottie/arrow-sequences/arrow-4.json';
import arrow5 from 'public/assets/lottie/arrow-sequences/arrow-5.json';

export const SERVICES_LOBBY_CARDS_LOTTIES = [arrow1, arrow2, arrow3, arrow4, arrow5] as const;
